<template>
    <div class="portfolio">
        <div>
            <div class="menu-name">포트폴리오</div>
            <div class="submenu" :class="{show: $route.path.includes('portfolio')}">
                <div v-for="(categoryId, categoryName) in portfolioSubmenus" @click="redirectSubmenu(categoryId)" :class="{bold: py === categoryId}">{{categoryName}}</div>
            </div>
            <div v-if="!$route.fullPath.includes('product_no')" class="list" :class="{show: listShow}">
                <template v-for="(product, index) in products">
                    <img class="portfolio-image disable-save sm-skel" :key="product.product_no" @load="$event.target.classList.add('sm-loaded')" @click="findProduct(product.product_no)" :src="isDesktop ? getOriginalUrl(product.list_image) : getThumbUrl(product.list_image)" :alt="product.product_name"
                         :loading="index < 2 ? 'eager' : 'lazy'"
                         :fetchpriority="index === 0 ? 'high' : undefined"
                         decoding="async"
                         :width="product.list_image_width"
                         :height="product.list_image_height"
                         oncontextmenu="return false;"
                    />
                </template>
            </div>
        </div>
        <template v-if="$route.fullPath.includes('product_no') && portfolio">
            <div class="product-name">{{portfolio.product_name}}</div>
            <div v-if="(portfolio.__source === 'firestore' || portfolio.__source === 'sqlite') && portfolio.images && portfolio.images.length > 0" class="content disable-save" oncontextmenu="return false;">
                <img v-for="(u, i) in portfolio.images" :key="i" :src="isDesktop ? getOriginalUrl(u) : getThumbUrl(u)" :alt="portfolio.product_name"
                     :loading="i === 0 ? 'eager' : 'lazy'"
                     :fetchpriority="i === 0 ? 'high' : undefined"
                     decoding="async"
                     :width="imgDim(i, 0)" :height="imgDim(i, 1)"/>
            </div>
            <template v-else>
                <div class="content disable-save"
                     oncontextmenu="return false;"
                     v-html='portfolio.description.replace(/src="\/web/g, `src="${backendUrl}/web`)'
                ></div>
            </template>
        </template>
    </div>
</template>

<script>
import {Vue, Component, Prop} from 'vue-property-decorator'
import {productToCategory, productToPy, pyToCategory} from "@/components/common";
import {categories} from '@/cafe24info'
import { getThumbUrl, getOriginalUrl } from '@/utils/thumbnail'

@Component
export default class Portfolio extends Vue {
    @Prop() product_no
    listShow = false
    portfolioSubmenus = categories['portfolio']
    getThumbUrl = getThumbUrl
    getOriginalUrl = getOriginalUrl

    get products () {
        return this.$store.getters.products
    }

    get py () {
        return this.$store.getters.py
    }

    get isDesktop() {
        return window.innerWidth > 460
    }

    get portfolio () {
        return this.$store.getters.portfolio
    }

    get backendUrl () {
        return process.env.VUE_APP_BACKEND || 'https://sun-mooninterior.com'
    }

    async findProduct (product_no) {
        await this.$store.dispatch('findPortfolio', product_no)
        await this.$store.commit('py', productToCategory(this.portfolio))
        await this.$router.push({name: 'portfolio', query: {product_no}}).then().catch(() => {})
    }

    async redirectSubmenu(categoryId) {
        this.listShow = false
        await this.$router.push({name: 'portfolio', query: {}}).then().catch(() => {})
        this.$store.commit('py', categoryId)
        await this.$store.dispatch('findPortfolioList', categoryId)
        this.listShow = true

    }

    async beforeMount () {
        if (this.product_no) {
            await this.$store.dispatch('findPortfolio', this.product_no)
            await this.$store.dispatch('findPortfolioList', productToCategory(this.portfolio))
        } else {
            await this.$store.dispatch('findPortfolioList', this.py)
        }
        this.listShow = true
    }

    mounted () {
        this.markSkeleton()
    }

    updated () {
        this.markSkeleton()
    }

    // Firestore-apartment detail images carry their intrinsic size in portfolio.imageSizes
    // ("WxH"); return the requested axis (0=width,1=height) so the box reserves space for
    // native lazy-loading and avoids layout shift. Falls back to undefined (natural) when absent.
    imgDim (i, axis) {
        const sizes = this.portfolio && this.portfolio.imageSizes
        const s = (sizes && sizes[i]) || ''
        const m = /^(\d+)x(\d+)$/.exec(s)
        return m ? Number(m[axis + 1]) : undefined
    }

    // Detail photos render via v-html (no Vue @load), so add the shimmer skeleton
    // to each and clear it once the image finishes loading.
    markSkeleton () {
        if (!this.$el || !this.$el.querySelectorAll) return
        this.$el.querySelectorAll('.content img:not(.sm-skel)').forEach(img => {
            img.classList.add('sm-skel')
            if (img.complete && img.naturalWidth > 0) img.classList.add('sm-loaded')
            else img.addEventListener('load', () => img.classList.add('sm-loaded'), { once: true })
        })
    }
}
</script>

<style scoped lang="scss">
@import 'src/assets/style/media-query';
.portfolio {
    .product-name {
        text-align: center;
        font-size: 14px;
        @include desktop {
            font-size: 24px;
        }
        margin-top: 30px;
    }
}
.list {
    overflow-y: auto;
    height: inherit;
    opacity: 0;

    width: 100%;
    &.show {
        opacity: 1;
        transition: opacity 0.5s ease-in;
    }
    img {
        width: 100%;
        height: 250px;
        object-fit: cover;
        @include desktop {
            width: 49%;
            height: 400px;
            margin-right: 10px;
        }
        padding-bottom: 3px;
        cursor: pointer;
    }
    .bold {
        font-weight: bold;
    }
}
.content {
    overflow-y: auto;
    overflow-x: hidden;
    width: -webkit-fill-available;
    height: inherit;
    ::v-deep p {
    }

    img, ::v-deep img {
        width: 100%;
        height: auto;
        max-width: 1999px;
        min-height: 0 !important;
    }
}

.submenu {
    display: flex;
    padding-bottom: 3px;
    font-size: 20px;
    justify-content: space-around;
    margin: 10px 0;

    div {
        margin-right: 10px;
        cursor: pointer;

        &.bold {
            font-weight: bold;
            color: black;
        }
    }

    @include mobile {
        justify-content: space-evenly;
        padding-top: 25px;
        font-size: 12px;
    }
}
</style>